import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const PrivacyPage = () => (
  <div className="min-h-screen bg-white">
    <SEO
      title="Privacy Policy | Paisley Scotland"
      description="How Paisley Scotland collects, uses and protects your personal data in line with UK GDPR and the Data Protection Act 2018."
      url="https://paisleyscotland.com/privacy"
    />
    <Navbar />
    <article className="pt-28 pb-20" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate prose-lg">
        <h1 className="font-heading">Privacy Policy</h1>
        <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString('en-GB')}</p>

        <p>
          Paisley Scotland (“we”, “our”, “us”) operates the website
          <a href="https://paisleyscotland.com"> paisleyscotland.com</a>. This Privacy
          Policy explains how we collect, use and protect your personal information
          in accordance with the UK General Data Protection Regulation (UK GDPR) and
          the Data Protection Act 2018.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li><strong>Contact details</strong> you provide via our contact form, sponsorship registration or event spotlight submission (name, email, phone, business name).</li>
          <li><strong>Newsletter sign-ups</strong> — your email address only.</li>
          <li><strong>Payment data</strong> processed by Stripe — we never store full card details on our servers.</li>
          <li><strong>Technical data</strong> — anonymous analytics (pages visited, device type) used to improve the service.</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To respond to enquiries and provide the services you requested.</li>
          <li>To send the newsletter you opted into (you can unsubscribe at any time).</li>
          <li>To process sponsorship and event-promotion payments.</li>
          <li>To improve the website and uphold legitimate business interests.</li>
        </ul>

        <h2>3. Legal Basis</h2>
        <p>
          We process your data under one or more of the following lawful bases:
          consent, performance of a contract, or our legitimate interest in
          operating and improving the platform.
        </p>

        <h2>4. Sharing Your Data</h2>
        <p>
          We do not sell your data. We share it only with trusted processors who
          help us run the service — Stripe (payments), Resend (email delivery),
          MongoDB Atlas (database hosting) and Emergent Agent (application
          hosting & object storage). All processors are bound by appropriate data
          protection agreements.
        </p>

        <h2>5. Cookies</h2>
        <p>
          We use a minimal set of essential cookies required for site functionality
          and may use anonymous analytics cookies to understand site usage. No
          third-party advertising cookies are deployed.
        </p>

        <h2>6. Your Rights</h2>
        <p>
          Under UK GDPR you may request access to your data, ask us to correct or
          delete it, withdraw consent, or object to processing. Contact us at
          <a href="mailto:brian@paisley.org.uk"> brian@paisley.org.uk</a> to exercise any
          of these rights. You also have the right to lodge a complaint with the
          UK Information Commissioner’s Office (ico.org.uk).
        </p>

        <h2>7. Data Retention</h2>
        <p>
          We retain personal data only for as long as necessary to fulfil the
          purposes for which it was collected, or as required by law.
        </p>

        <h2>8. Contact</h2>
        <p>
          Questions about this policy? Email
          <a href="mailto:brian@paisley.org.uk"> brian@paisley.org.uk</a> or write to
          Paisley Scotland, Paisley, Renfrewshire, Scotland, UK.
        </p>
      </div>
    </article>
    <Footer />
  </div>
);

export default PrivacyPage;
